module.exports = __webpack_public_path__ + "img/Steor-Icon-03.e1568bf7.svg";